/**
 * Session ID Management per Guest Checkout
 *
 * Genera e gestisce UUID univoco per identificare utenti guest
 * Salvato in localStorage per persistenza tra sessioni
 */

import { v4 as uuidv4 } from 'uuid';

const SESSION_KEY = 'cart_session_id';

/**
 * Recupera session_id esistente o ne crea uno nuovo
 *
 * @returns {string} UUID session_id
 */
export const getSessionId = () => {
  let sessionId = localStorage.getItem(SESSION_KEY);

  if (!sessionId) {
    sessionId = uuidv4();
    localStorage.setItem(SESSION_KEY, sessionId);
  }

  return sessionId;
};

/**
 * Pulisce session_id (usato dopo checkout completato)
 */
export const clearSession = () => {
  localStorage.removeItem(SESSION_KEY);
};

/**
 * Setta manualmente un session_id (utile per merge al login)
 *
 * @param {string} sessionId
 */
export const setSessionId = (sessionId) => {
  localStorage.setItem(SESSION_KEY, sessionId);
};

/**
 * Controlla se esiste un session_id
 *
 * @returns {boolean}
 */
export const hasSession = () => {
  return localStorage.getItem(SESSION_KEY) !== null;
};
